class Wishlist {
  constructor() {
    this.key = 'neolina_wishlist';
  }

  getItems() {
    try {
      return JSON.parse(localStorage.getItem(this.key)) || [];
    } catch {
      return [];
    }
  }

  _save(items) {
    localStorage.setItem(this.key, JSON.stringify(items));
  }

  add(handle, data) {
    const items = this.getItems();
    if (!items.find((i) => i.handle === handle)) {
      items.push(data);
      this._save(items);
    }
    this._dispatch();
  }

  remove(handle) {
    this._save(this.getItems().filter((i) => i.handle !== handle));
    this._dispatch();
  }

  toggle(handle, data) {
    if (this.has(handle)) {
      this.remove(handle);
      return false;
    }
    this.add(handle, data);
    return true;
  }

  has(handle) {
    return !!this.getItems().find((i) => i.handle === handle);
  }

  count() {
    return this.getItems().length;
  }

  _dispatch() {
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: this.count() } }));
  }
}

window.wishlist = new Wishlist();

function popBadge(el) {
  el.classList.remove('badge-pop');
  void el.offsetWidth;
  el.classList.add('badge-pop');
}

function setMobileAtcBadge(btn, count) {
  var badge = btn.querySelector('.card__mobile-atc-count');
  if (!badge) {
    badge = document.createElement('span');
    badge.className = 'card__mobile-atc-count';
    btn.appendChild(badge);
  }
  badge.textContent = count;
  badge.style.display = count > 0 ? 'flex' : 'none';
  if (count > 0) popBadge(badge);
}

function applyMobileAtcBadges(cart) {
  var btns = document.querySelectorAll('.card__mobile-atc[data-variant-id]');
  btns.forEach(function (btn) {
    var variantId = parseInt(btn.dataset.variantId, 10);
    var item = cart.items.find(function (i) { return i.variant_id === variantId; });
    setMobileAtcBadge(btn, item ? item.quantity : 0);
  });
}

function syncAllMobileAtcBadges(cartData) {
  var btns = document.querySelectorAll('.card__mobile-atc[data-variant-id]');
  if (!btns.length) return;
  if (cartData && Array.isArray(cartData.items)) {
    applyMobileAtcBadges(cartData);
    return;
  }
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(applyMobileAtcBadges)
    .catch(function () {});
}

// Sync badges on page load (for server-rendered card__mobile-atc buttons, e.g. homepage cards)
document.addEventListener('DOMContentLoaded', function () { syncAllMobileAtcBadges(); });

// Re-sync when page is restored from bfcache (mobile back/forward navigation)
window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    syncAllMobileAtcBadges();
    refreshWishlistButtons();
    refreshWishlistHeader();
  }
});

// Keep badges in sync whenever any ATC action updates the cart during the same page session
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, function (detail) { syncAllMobileAtcBadges(detail && detail.cartData); });
}

window.neolinaAddToCart = function (btn) {
  var variantId = btn.dataset.variantId;
  if (!variantId || btn.disabled) return;

  var isMobileBtn = btn.classList.contains('card__mobile-atc');
  var original = isMobileBtn ? null : btn.textContent.trim();
  var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  btn.disabled = true;
  if (isMobileBtn) {
    btn.classList.add('card__mobile-atc--adding');
  } else {
    btn.textContent = '…';
  }

  if (cart) cart.setActiveElement(btn);

  var body = { id: parseInt(variantId, 10), quantity: 1 };
  if (cart) {
    body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
    body.sections_url = window.location.pathname;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
    .then(function (r) {
      if (!r.ok) throw new Error('cart/add failed');
      return r.json();
    })
    .then(function (response) {
      if (cart && typeof cart.renderContents === 'function') {
        cart.renderContents(response);
      }

      if (isMobileBtn) {
        btn.classList.remove('card__mobile-atc--adding');
        var badge = btn.querySelector('.card__mobile-atc-count');
        var current = badge ? (parseInt(badge.textContent, 10) || 0) : 0;
        setMobileAtcBadge(btn, current + 1);
      } else {
        btn.textContent = '✓';
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wishlist', cartData: response });
      }

      setTimeout(function () {
        if (!isMobileBtn) btn.textContent = original;
        btn.disabled = false;
      }, isMobileBtn ? 0 : 1500);
    })
    .catch(function () {
      if (isMobileBtn) btn.classList.remove('card__mobile-atc--adding');
      else btn.textContent = original;
      btn.disabled = false;
    });
};

function suppressTapHighlight(btn) {
  btn.style.webkitTapHighlightColor = 'rgba(0,0,0,0)';
  btn.querySelectorAll('*').forEach((child) => {
    child.style.webkitTapHighlightColor = 'rgba(0,0,0,0)';
  });
}

function refreshWishlistButtons() {
  document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
    const active = window.wishlist.has(btn.dataset.handle);
    btn.classList.toggle('wishlist-btn--active', active);
    btn.setAttribute('aria-pressed', String(active));
    suppressTapHighlight(btn);
  });
}

function refreshWishlistHeader() {
  const count = window.wishlist.count();
  document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
    const prev = parseInt(el.textContent, 10) || 0;
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
    if (count > 0 && count !== prev) popBadge(el);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  refreshWishlistButtons();
  refreshWishlistHeader();

  document.addEventListener('wishlist:updated', () => {
    refreshWishlistButtons();
    refreshWishlistHeader();
  });

  document.addEventListener('recommendations:loaded', refreshWishlistButtons);

  document.addEventListener('touchstart', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    suppressTapHighlight(btn);
  }, { passive: true });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const { handle } = btn.dataset;
    const data = {
      handle,
      title: btn.dataset.title,
      price: btn.dataset.price,
      volume: btn.dataset.volume || '',
      image: btn.dataset.image,
      secondImage: btn.dataset.secondImage || '',
      url: btn.dataset.url,
      variantId: btn.dataset.variantId || null,
      variantsCount: parseInt(btn.dataset.variantsCount, 10) || 1,
    };
    const active = window.wishlist.toggle(handle, data);
    btn.classList.toggle('wishlist-btn--active', active);
    btn.setAttribute('aria-pressed', String(active));
  });
});
